/** @type {any} */
(window).initIconLinkBoxes = function init() {
  "use strict";

  /** @type {string} */
  const CONTAINER_CLASS = ".element-icon-link-boxes";
  /** @type {string} */
  const WRAPPER_CLASS = ".element-icon-link-boxes--wrap";
  /** @type {string} */
  const ITEM_CLASS = ".icon-link-box";
  /** @type {string} */
  const WIDTH_CONTAINER_CLASS = ".width-container";
  /** @type {number} */
  const BREAKPOINT = 540; // mobile breakpoint
  /** @type {number} */
  const MIN_WIDTH_PERCENT = 50; // stop shrinking at 50%

  /**
   * Reset container for mobile layout
   * @param {HTMLElement | null} widthContainer
   * @returns {void}
   */
  const defaultToMobile = (widthContainer) => {
    if (!widthContainer) {
      return;
    }
    widthContainer.style.width = "100%";
    widthContainer.style.alignItems = "unset";
  };

  /**
   * Adjust widthContainer so last row has >=2 items
   * Shrinks iteratively if needed
   * @param {HTMLElement} wrapper
   * @param {HTMLElement} widthContainer
   * @returns {void}
   */
  const adjustContainerWidth = (wrapper, widthContainer) => {
    /** @type {Element[]} */
    const items = Array.from(wrapper.querySelectorAll(ITEM_CLASS));
    if (items.length < 2) {
      return;
    }

    // Reset width to natural CSS width first
    widthContainer.style.width = "100%";
    widthContainer.style.alignItems = "";

    let containerWidthPercent = 100;
    widthContainer.style.width = `${containerWidthPercent}%`;

    // Iteratively shrink until last row has ≥2 items or reach MIN_WIDTH_PERCENT
    while (containerWidthPercent > MIN_WIDTH_PERCENT) {
      /** @type {Element[][]} */
      const rows = [];
      /** @type {Element[]} */
      let currentRow = [];
      /** @type {number | null} */
      let currentTop = null;

      items.forEach((item) => {
        const itemTop = Math.round(item.getBoundingClientRect().top);
        if (currentTop === null || itemTop === currentTop) {
          currentRow.push(item);
          currentTop = itemTop;
          return;
        }

        rows.push(currentRow);
        currentRow = [item];
        currentTop = itemTop;
      });

      if (currentRow.length) {
        rows.push(currentRow);
      }

      const lastRow = rows[rows.length - 1];
      if (!lastRow) {
        break;
      }

      const hasOrphanRow = rows.some((row) => row.length === 1);

      if (containerWidthPercent - 1 === MIN_WIDTH_PERCENT && hasOrphanRow) {
        defaultToMobile(widthContainer);
        break;
      }

      // If no row has a single item or only one row exists, done
      if (!hasOrphanRow || rows.length === 1) {
        break;
      }

      // Some row has 1 item → shrink container slightly
      containerWidthPercent -= 1;
      widthContainer.style.width = `${containerWidthPercent}%`;
    }
  };

  /**
   * Initialize a single container/block
   * @param {HTMLElement | null} container
   * @returns {void}
   */
  const initBlock = (container) => {
    if (!container) {
      return;
    }

    /** @type {HTMLElement | null} */
    const wrapper = container.querySelector(WRAPPER_CLASS);
    /** @type {HTMLElement | null} */
    const widthContainer = container.querySelector(WIDTH_CONTAINER_CLASS);
    if (!wrapper || !widthContainer) {
      return;
    }

    // Mobile layout
    if (window.innerWidth < BREAKPOINT) {
      defaultToMobile(widthContainer);
      return;
    }

    adjustContainerWidth(wrapper, widthContainer);
  };

  /**
   * Initialize all icon link blocks
   * @returns {void}
   */
  const initializeAllBlocks = () => {
    /** @type {NodeListOf<Element>} */
    const blocks = document.querySelectorAll(CONTAINER_CLASS);
    blocks.forEach((block) => initBlock(/** @type {HTMLElement} */ (block)));
  };

  // Run the initializer when this module function is invoked
  initializeAllBlocks();
};

// Initialize on DOMContentLoaded
window.addEventListener(
  "DOMContentLoaded",
  /** @type {any} */ (window).initIconLinkBoxes,
);

// Debounced resize
/** @type {number | null} */
let resizeTimeout = null;
window.addEventListener("resize", () => {
  if (resizeTimeout !== null) {
    clearTimeout(resizeTimeout);
  }
  // 150 is the RESIZE_DEBOUNCE value from the scoped module
  resizeTimeout = window.setTimeout(
    /** @type {any} */ (window).initIconLinkBoxes,
    150,
  );
});
